export class Scheduling {
    date: string;
    period: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/models/payment/scheduling.ts